const FILTERS = {
  FILTER_FUNNEL: {
    dark: "/svg/filters/filter_funnel_dark.svg",
  },
};

export default FILTERS;
